/**
 * @deprecated Redux no longer owns session profile data. Kept as a logout reset stub
 * for store shape compatibility until remaining test fixtures drop `profile`.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { ProfileType } from "store/types/profile";
import { SignupMethod } from "store/types/profile";

const initialProfileState: ProfileType = {
  user_id: "",
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  oauth2_sso_config_id: null,
  signup_method: SignupMethod.LOCAL,
  stripe_reference_id: null,
  pricing_plan: null,
  pricing_plan_id: null,
  is_active: true,
  verified: true,
  created_at: "",
  updated_at: "",
  profile_image_path: "",
  role: "user",
  mfa_enabled: false,
  one_time_purchases: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState: initialProfileState,
  reducers: {
    logout: () => initialProfileState,
  },
});

export const { logout } = profileSlice.actions;
export default profileSlice.reducer;
